export const googlePlaceRating = (placeId?: string) =>
  ['placeRating', placeId] as const
